import Form from 'react-bootstrap/Form';
import {Fragment, useEffect, useState} from "react";

export function SwitchRadio({
                                defaultValue,
                                onChangeValue
                            }) {
    const [value, setValue] = useState(defaultValue);
    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue]);

    return (
        <Fragment>
            <div className="d-flex">
                <label className="fs-13 mx-3 mt-1">設定</label>
                <div className="form-switch-wrapper">
                    <Form.Check
                        type="switch"
                        checked={value}
                        onChange={(e) => {
                            onChangeValue(e.target.checked)
                        }}
                        className="custom-switch cursor-pointer"

                    />
                    <label className="label-switch-radio">{Boolean(value) ? 'する' : 'しない'}</label>
                </div>

            </div>
        </Fragment>
    );
}

